import React from 'react'

export default function Button ({
  children,
  variant = 'solid',
  iconSize = 'S',
  mode = 'light',
  iconLeft,
  iconRight,
  disabled = false,
  loading = false,
  className = '',
  type = 'button',
  ...props
}) {
  const iconOnly = variant === 'icon'
  const visualVariant = iconOnly ? 'solid' : variant
  return (
    <button
      type={type}
      className={`ui-button ui-button--${visualVariant}${iconOnly ? ' ui-button--icon' : ''} ${className}`.trim()}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      data-size={iconOnly ? iconSize : undefined}
      data-mode={mode}
      {...props}
    >
      {loading && <span className='ui-spinner' aria-hidden='true' />}
      {loading && <span className='ui-sr-only'>{children}</span>}
      {!loading && iconLeft}
      {!loading && children}
      {!loading && iconRight}
    </button>
  )
}
